export default [
	{
		path: "/admin/funnels",
		exact: true,
		policy: "superAdminAuth",
		component: "AdminFunnelSteps",
	},
];
